@file:OptIn(InternalResourceApi::class)

package ifaandroid.core.ui_kit.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/ifaandroid.core.ui_kit.generated.resources/"

@delegate:ResourceContentHash(1_987_504_191)
public val Res.drawable.ic_arrow_left: DrawableResource by lazy {
      DrawableResource("drawable:ic_arrow_left", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_arrow_left.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_282_972_485)
public val Res.drawable.ic_arrow_left_ios: DrawableResource by lazy {
      DrawableResource("drawable:ic_arrow_left_ios", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_arrow_left_ios.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_561_474_636)
public val Res.drawable.ic_arrow_right: DrawableResource by lazy {
      DrawableResource("drawable:ic_arrow_right", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_arrow_right.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(218_863_635)
public val Res.drawable.ic_bottle: DrawableResource by lazy {
      DrawableResource("drawable:ic_bottle", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_bottle.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_623_225_647)
public val Res.drawable.ic_cart_20: DrawableResource by lazy {
      DrawableResource("drawable:ic_cart_20", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_cart_20.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(752_830_686)
public val Res.drawable.ic_checkmark_24: DrawableResource by lazy {
      DrawableResource("drawable:ic_checkmark_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_checkmark_24.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_010_827_302)
public val Res.drawable.ic_checkmark_checked_orange: DrawableResource by lazy {
      DrawableResource("drawable:ic_checkmark_checked_orange", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_checkmark_checked_orange.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_581_606_098)
public val Res.drawable.ic_checkmark_unchecked_orange: DrawableResource by lazy {
      DrawableResource("drawable:ic_checkmark_unchecked_orange", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_checkmark_unchecked_orange.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(35_279_410)
public val Res.drawable.ic_file_checked: DrawableResource by lazy {
      DrawableResource("drawable:ic_file_checked", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_file_checked.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(447_556_009)
public val Res.drawable.ic_pizza: DrawableResource by lazy {
      DrawableResource("drawable:ic_pizza", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_pizza.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-58_139_928)
public val Res.drawable.ic_steps: DrawableResource by lazy {
      DrawableResource("drawable:ic_steps", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_steps.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("ic_arrow_left", Res.drawable.ic_arrow_left)
  map.put("ic_arrow_left_ios", Res.drawable.ic_arrow_left_ios)
  map.put("ic_arrow_right", Res.drawable.ic_arrow_right)
  map.put("ic_bottle", Res.drawable.ic_bottle)
  map.put("ic_cart_20", Res.drawable.ic_cart_20)
  map.put("ic_checkmark_24", Res.drawable.ic_checkmark_24)
  map.put("ic_checkmark_checked_orange", Res.drawable.ic_checkmark_checked_orange)
  map.put("ic_checkmark_unchecked_orange", Res.drawable.ic_checkmark_unchecked_orange)
  map.put("ic_file_checked", Res.drawable.ic_file_checked)
  map.put("ic_pizza", Res.drawable.ic_pizza)
  map.put("ic_steps", Res.drawable.ic_steps)
}
